import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Committeeleft from './Committeeleft';
import Breadcrumb from '../../Breadcrumb/Main'
import { Table } from 'react-bootstrap';

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Library Advisory Committee" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        
                        <Row>

                                <Col md={3} className='c-left custom-padding-color mb-4'>
                                <Committeeleft></Committeeleft>
                                </Col>

                                <Col md={9} className='c-right'>


                           
                                <h3 className='c-headline mb-3'>Library Advisory Committee</h3>
                                <p className='caboutus c-lineheight2dot5'>The Library Advisory Committee of the Institute is re-constituted with the following composition for a period of two years or until further orders, whichever is earlier: </p>

                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>Prof. Sasidhar Gumma</p>
                                                <p>Dean - Academic Affairs</p>
                                            </td>
                                            <td>Chairperson<br /> (Ex-Officio)</td>
                                        </tr>


                                        <tr>
                                            <td>
                                                <p>Dr. Narendra Singh</p>
                                                <p>Associate Professor - Department of Chemical Engineering</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Srikrishna Bera</p>
                                                <p>Assistant Professor - Department of Chemistry</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Prof. Shihabudheen M. Maliyekkal</p>
                                                <p>Professor - Department of Civil and Environmental Engineening</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Dr. Raghavendra Kanakagiri</p>
                                                <p>Assistant Professor - Department of Computer Science and Engineening</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Swapnil Bhuktare</p>
                                                <p>Associate Professor - Department of Electrical Engineering</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Dr. Arvind Kumar Pandey</p>
                                                <p>Assistant Professor - Department of Humanities and Social Scences</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Dr. Angshuman Roy</p>
                                                <p>Assistant Professor - Department of Mathematics and Statistics</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Dr. Mohd. Furquan</p>
                                                <p>Assistant Professor - Department of Mechanical Engineening</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        
                                        
                                        <tr>
                                            <td>
                                                <p>Dr. Arijit Sharma</p>
                                                <p>Associate Professor - Department of Physics</p>
                                            </td>
                                            <td>Invitee</td>
                                        </tr>
                                       
                                        <tr>
                                            <td>
                                                <p>Mr. Prashanta Kumar Behera</p>
                                                <p>Deputy Librarian</p>
                                            </td>
                                            <td>Convenor <br />(Ex-Officio)</td>
                                        </tr>
                                    </tbody>

                                </Table>

                               

                            </Col>

                            
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;